import core from './core';

export default {
  get(vendorId) {
    return core.get(`agents`);
  },
}
